import React from 'react';
import { observer, inject } from 'mobx-react';

import Container from 'js/components/core/ReviewPanel/Container';
import Row from 'js/components/core/ReviewPanel/Row';
import Label from 'js/components/core/ReviewPanel/Label';
import Content from 'js/components/core/ReviewPanel/Content';
import EditButton from 'js/components/core/ReviewPanel/EditButton';

import LineItems from './LineItems';
import Notice from './Notice';

export default inject('page')(
  observer(({ page }) => (
    <Container>
      <Row hasError={!page.address.hasAddress} onClick={page.editDeliveryAddress}>
        <Label>SHIP TO</Label>
        <Content>
          <div>
            {page.address.address1}
            {page.address.address2 && `, ${page.address.address2}`}
          </div>
          <div>
            {page.address.city} {page.address.state}, {page.address.zip}
          </div>
        </Content>
        <EditButton />
      </Row>

      <Row hasError={!page.shipping_service} onClick={page.editShipping}>
        <Label>METHOD</Label>
        <Content>
          {page.shipping_service ? (
            `${
              page.shipping_service.isSameDay
                ? `Same-Day ${page.shipping_service.delivery === 'short' ? '2h' : '6h'}`
                : 'Standard (2-4d)'
            } with ${page.shipping_service.brand}`
          ) : (
            <Notice>Please select shipping</Notice>
          )}
        </Content>
        <EditButton />
      </Row>

      <Row hasError={!page.credit_card.isFilledIn} onClick={page.editPaymentMethod}>
        <Label>PAYMENT</Label>
        <Content>{`${page.credit_card.cc_type.toUpperCase()} ending in ${page.credit_card.number.slice(-4)}`}</Content>
        <EditButton />
      </Row>

      <Row>
        <Label>ORDER</Label>
        <LineItems />
      </Row>
    </Container>
  )),
);
